"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeDisabledComponent = void 0;
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const tree_styles_1 = require("./tree-styles");
function TreeDisabledComponent(props) {
    var _a;
    const classes = tree_styles_1.useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null, (_a = props.value) === null || _a === void 0 ? void 0 : _a.map((v) => (react_1.default.createElement(Typography_1.default, { key: v.id, variant: "body1", className: classes.disabledComponent }, v.label)))));
}
exports.TreeDisabledComponent = TreeDisabledComponent;
//# sourceMappingURL=tree-disabled-component.js.map